var Reports = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = opts || {};
    this.init();
};

Reports.prototype = {
    constructor: Reports,
    $el: undefined,
    options: undefined,
    type: undefined,
    $table: undefined,
    init: function() {
        var self = this;

        self.$table = self.$el.find('.table');
        self.type = self.$table.attr('data-type');

        self.populateColumns();
        self.populateData();

        // handle export
        self.$el.find('.export-btn').on('click', function(evt) {
            var $this = $(evt.currentTarget);
            var holiday = self.$el.find('.holiday-select option:selected').attr('data-holiday-id');
            var url = $this.hasClass('dropdown-item')
                ? $this.attr('data-url')
                : $this.closest('.btn-group').find('.default-btn').attr('data-url');
            if ($this.hasClass('pdf-btn')) {
                var opt = {
                    margin:       0.1,
                    filename:     'export-' + self.type + '.pdf',
                    image:        { type: 'jpeg', quality: 0.98 },
                    html2canvas:  { scale: 2 },
                    jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
                };
                html2pdf().set(opt).from(self.$table[0]).save();
                evt.preventDefault();
                return false;
            }
            if (holiday) {
                url += `?holiday=${holiday}`;
            }
            if (url) {
                window.location.href = url;
            }
        });

        self.$el.find('.print-btn').on('click', function(evt) {
            var $this = $(evt.currentTarget);
            var holiday = self.$el.find('.holiday-select option:selected').attr('data-holiday-id');
            var url = $this.attr('data-url') + (holiday ? `?holiday=${holiday}` : '');
            if (url) {
                $.get(url).done(function(response) {
                    var w = window.open("about:blank", "", "width=800,height=600");
                    if (w) {
                        w.document.write(response);
                        w.document.close();
                        w.focus();
                        w.print();
                        w.close();
                    }
                });
            }
        });

        self.$el.find('.holiday-select').on('change', function() {
            self.populateData();
        });
    },
    populateColumns: function() {
        var self = this;
        $.get('/admin/reports/' + self.type + '/columns').done(function(response) {
            var $tr = $('<tr>');
            Object.keys(response).forEach(function(key) {
                var $th = $('<th>');
                $th.append(response[key]);
                $th.attr('data-field', key);
                $tr.append($th);
            });
            self.$table.find('thead').append($tr);
        });
    },
    populateData: function() {
        var self = this,
            handler = self.populateDataHandler(),
            $holidayOption = self.$el.find('.holiday-select option:selected'),
            id = $holidayOption.attr('data-holiday-id') ?? null,
            $spinner = self.$el.find('.data-spinner');
        $spinner.removeClass("d-none");
        var dataUrl = '/admin/reports/' + self.type + '/data' + (id ? '?holiday=' + id : '');
        if (window.location.search.match('use-old-reports=true')) {
            dataUrl += (dataUrl.indexOf('?') !== -1 ? '&' : '?') + 'use-old-reports=true';
        }
        $.get(dataUrl).done(function(response) {
            handler(response);
            $spinner.addClass('d-none');
        });
    },
    populateDataHandler: function() {
        var self = this,
            cb = null;
        switch (self.type) {
            case 'pies-bakery':
            case 'prep-totals':
            case 'cakes':
            case 'cakes-early-pickup':
                cb = function(data) {
                    var category = null,
                        first = true;
                    self.$table.find('tbody').html('');
                    for (var i = 0; i < data.length; i++) {
                        if (!category || category !== data[i].category) {
                            category = data[i].category;
                            first = true;
                        }
                        else {
                            first = false;
                        }
                        var $tr = $('<tr>');
                        var row = data[i];
                        Object.keys(row).forEach(function(key) {
                            var $td = $('<td>');
                            if (key === 'category') {
                                var cls = !first ? ' class="visually-hidden"' : '';
                                $td.append('<span' + cls + '>' + row[key] + '</span>');
                            }
                            else {
                                $td.append(row[key]);
                            }
                            $tr.append($td);
                        });
                        self.$table.find('tbody').append($tr);
                    }
                };
                break;
            default:
                cb = function(data) {
                    self.$table.find('tbody').html('');
                    for (var i = 0; i < data.length; i++) {
                        var $tr = $('<tr>');
                        var row = data[i];
                        Object.keys(row).forEach(function(key) {
                            var $td = $('<td>');
                            $td.append(row[key]);
                            $tr.append($td);
                        });
                        self.$table.find('tbody').append($tr);
                    }
                };
        }
        return cb;
    }
}

module.exports = Reports;
